export default {
  参观商: 'Buyer',
  主办商: 'Event Organizer',
  主办方: 'Event Organizer',
  参展商: 'Exhibitor',
  设计师: 'Designer',
  工程商: 'Contractor',
  展厅工程商: 'Contractor',
  服务商: 'Service Provider',
  申请成为参展商: 'You are applying to get verified as Exhibitor',
  申请成为主办方: 'You are applying to get verified as Event Organizer',
  申请成为主办商: 'You are applying to get verified as Event Organizer',
  申请成为设计师: 'You are applying to get verified as Designer',
  申请成为工程商: 'You are applying to get verified as Contractor',
}
